import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Takoma Park Cannabis · Informational Hub</p>
        <h1>Your Source for Cannabis Policy and Culture News</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural developments in your area. Our platform provides comprehensive coverage and educational resources to help you navigate the evolving landscape of cannabis legislation.
        </p>
        <div className="cta-row">
          <a href="/latest-updates" target="_self">
            Explore Latest Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and policy in Takoma Park and surrounding areas. Our news coverage ensures you are always informed about your rights and responsibilities.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality with our informative guides. We break down the current legal status and what it means for residents and visitors alike.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Dive into our resources designed to educate the community about cannabis culture, safety, and responsible use. Empower yourself with knowledge and stay engaged in the conversation.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;